export default __webpack_public_path__ + "static/media/Success.46c00113.svg";